import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/changeProfileModal.scss";

/**
 * ChangeProfileModal — Dark card modal centered on screen
 * Figma: 1.2 Change profile (Desktop) (24654:4993) — 570×429
 *
 * Dark card (#262626) with header/body/footer sections separated by borders.
 *   - Header: "Change profile" + "Select a profile to continue" + close (X)
 *   - Body: Profile avatars with initials + lock icons
 *   - Footer: "Manage Profile" outline button
 *
 * @param {boolean} isOpen — show/hide modal
 * @param {function} onClose — close handler
 * @param {function} onSelectProfile — profile click handler
 * @param {function} onPinRequired — callback when profile requires PIN
 */

const PROFILES = [
  { id: 1, name: "Dean", initial: "D", color: "#2563eb", hasPIN: true },
  { id: 2, name: "Selly", initial: "S", color: "#9333ea", hasPIN: true },
  { id: 3, name: "Ashley", initial: "S", color: "#22c55e", hasPIN: false },
];

const ChangeProfileModal = ({ isOpen, onClose, onSelectProfile, onPinRequired }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleProfileClick = (profile) => {
    if (profile.hasPIN) {
      onPinRequired?.(profile);
    } else {
      onSelectProfile?.(profile);
    }
  };

  return (
    <div className="change-profile-overlay" onClick={onClose}>
      <div className="change-profile-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="change-profile-modal__header">
          <div className="change-profile-modal__header-text">
            <h2 className="change-profile-modal__title">Change profile</h2>
            <p className="change-profile-modal__subtitle">Select a profile to continue</p>
          </div>
          <button className="change-profile-modal__close" onClick={onClose} aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="#a3a3a3" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Body — Profile avatars */}
        <div className="change-profile-modal__body">
          <div className="change-profile-modal__profiles">
            {PROFILES.map((profile) => (
              <button
                key={profile.id}
                className="change-profile-modal__profile"
                onClick={() => handleProfileClick(profile)}
              >
                <div className="change-profile-modal__avatar-wrapper">
                  <div
                    className="change-profile-modal__avatar"
                    style={{ backgroundColor: profile.color }}
                  >
                    <span className="change-profile-modal__initial">
                      {profile.initial}
                    </span>
                  </div>
                  {profile.hasPIN && (
                    <div className="change-profile-modal__lock">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <rect x="3" y="7" width="10" height="7" rx="2" fill="white"/>
                        <path d="M5 7V5.5C5 3.84 6.34 2.5 8 2.5C9.66 2.5 11 3.84 11 5.5V7" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </div>
                  )}
                </div>
                <span className="change-profile-modal__name">{profile.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="change-profile-modal__footer">
          <button
            className="change-profile-modal__manage-btn"
            onClick={() => {
              onClose?.();
              navigate("/settings/account");
            }}
          >
            Manage Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangeProfileModal;
